module.exports = {"340603001":"相南街道","340603002":"东街道","340603003":"西街道","340603004":"三堤口街道","340603005":"东山街道","340603006":"人民路街道","340603007":"刘桥街道","340603008":"任圩街道","340603009":"南黎","340603010":"曲阳","340603100":"渠沟镇","340603400":"淮北凤凰山经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340603.json
// module id = 993
// module chunks = 0